import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, Gift, ArrowRight, Tag } from "lucide-react";
import { api, BACKEND_URL } from "@/lib/api";

const KEY = "pp_exit_captured_v2";
const TAB_KEY = "pp_discount_tab";
export const alreadyCaptured = () => !!localStorage.getItem(KEY);
const BARKIBU = { key: "barkibu", name: "Barkibu", promo_code: "POLIZZAPET10", promo_value: 25 };

export function ExitCapture({ policy = BARKIBU, href, pet, estimate, onClose, onMinimize }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const target = href || `${BACKEND_URL}/api/go/barkibu`;

  const go = () => { window.open(target, "_blank", "noopener"); onClose(); };
  const minimize = () => { sessionStorage.setItem(TAB_KEY, "1"); window.dispatchEvent(new Event("pp-discount-tab")); (onMinimize || onClose)(); };
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/public/leads", { email, pet, estimate, consent_privacy: true, source: `exit-${policy.key}` });
      localStorage.setItem(KEY, "1");
      sessionStorage.removeItem(TAB_KEY);
      window.dispatchEvent(new Event("pp-discount-tab"));
    } catch { /* non bloccare l'utente */ }
    navigator.clipboard?.writeText(BARKIBU.promo_code).catch(() => {});
    go();
  };

  return (
    <div className="fixed inset-0 z-[100] grid place-items-center bg-black/50 p-4" onClick={minimize} data-testid="exit-capture-overlay">
      <form onSubmit={submit} onClick={(e) => e.stopPropagation()} className="relative w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl" data-testid="exit-capture-modal">
        <button type="button" onClick={minimize} className="absolute right-3 top-3 grid h-8 w-8 place-items-center rounded-full hover:bg-muted" aria-label="Chiudi" data-testid="exit-capture-close"><X size={16} /></button>
        <span className="grid h-11 w-11 place-items-center rounded-xl bg-amber-100 text-amber-700"><Gift size={22} /></span>
        <h3 className="font-display text-2xl font-bold mt-3 leading-tight">Ti abbiamo riservato 25€ di sconto</h3>
        <p className="text-sm text-muted-foreground mt-2">Sappiamo cosa significa avere paura quando sta male. Per questo ti abbiamo tenuto da parte uno sconto privato su Barkibu.</p>
        <input required type="email" className="input mt-4" placeholder="La tua email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="exit-capture-email" />
        <button className="btn-primary w-full mt-3 !py-3" disabled={loading} data-testid="exit-capture-submit">
          {loading ? "Un attimo…" : <>Sblocca i miei 25€ di sconto <ArrowRight size={16} /></>}
        </button>
        <button type="button" onClick={go} className="mt-3 w-full text-center text-xs text-muted-foreground underline" data-testid="exit-capture-skip">No grazie, rinuncio ai 25€ e preferisco pagare prezzo pieno →</button>
        <p className="mt-3 text-[10px] text-muted-foreground">Inviando accetti la <Link to="/privacy" className="underline">Privacy Policy</Link>. Nessuno spam.</p>
      </form>
    </div>
  );
}

export function DiscountTab() {
  const [show, setShow] = useState(() => !!sessionStorage.getItem(TAB_KEY) && !alreadyCaptured());
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const fn = () => setShow(!!sessionStorage.getItem(TAB_KEY) && !alreadyCaptured());
    window.addEventListener("pp-discount-tab", fn);
    return () => window.removeEventListener("pp-discount-tab", fn);
  }, []);
  if (!show) return null;
  return (
    <>
      <button onClick={() => setOpen(true)} className="fixed right-0 top-1/2 -translate-y-1/2 z-[90] rounded-l-xl bg-amber-500 hover:bg-amber-600 text-white px-2.5 py-4 shadow-xl transition-colors [writing-mode:vertical-rl] rotate-180 text-xs font-bold tracking-wide inline-flex items-center gap-2" data-testid="discount-tab">
        <Tag size={13} className="rotate-90" /> I tuoi −25€
      </button>
      {open && <ExitCapture onClose={() => setOpen(false)} onMinimize={() => setOpen(false)} />}
    </>
  );
}
